module.exports = __webpack_public_path__ + "static/media/team.21aa7606.jpg";